
import {appName} from '@/env';
import {Component, Vue} from 'vue-property-decorator';
import {
  readDashboardMiniDrawer,
  readDashboardShowDrawer,
  readForms,
  readHasAdminAccess,
  readHasModuleAccess, readMenuForms,
} from '@/store/main/getters';
import {commitSetDashboardMiniDrawer, commitSetDashboardShowDrawer} from '@/store/main/mutations';
import {dispatchUserLogOut} from '@/store/main/actions';
import VuePerfectScrollbar from 'vue-perfect-scrollbar/index.vue';
import ListGroup from '@/components/list/Group.vue';
import ListItem from '@/components/list/Item.vue';
import {readFormCategories} from "@/store/admin/getters";
import {IFormCategory} from "@/interfaces/form";
import {dispatchGetFormCategories} from "@/store/admin/actions";

@Component({
  components: {VuePerfectScrollbar, ListGroup, ListItem},
})
export default class AppDrawer extends Vue {

  public appName = appName;

  get miniDrawer() {
    return readDashboardMiniDrawer(this.$store);
  }

  get showDrawer() {
    return readDashboardShowDrawer(this.$store);
  }

  set showDrawer(value) {
    commitSetDashboardShowDrawer(this.$store, value);
  }

  public switchMiniDrawer() {
    commitSetDashboardMiniDrawer(
        this.$store,
        !readDashboardMiniDrawer(this.$store),
    );
  }

  public async logout() {
    await dispatchUserLogOut(this.$store);
  }

  public get hasAdminAccess() {
    return readHasAdminAccess(this.$store);
    // return true;
  }

  public hasModuleAccess(val) {
    return readHasModuleAccess(this.$store)(val);
  }

  public get scrollSettings() {
    return {
      maxScrollbarLength: 120,
    };
  }

  public get menuForms() {
    return readMenuForms(this.$store);
  }

  public get formCategories() {
    return readFormCategories(this.$store)
  }

  public formItems(route, metaValue, group) {
    let itens = [
      {title: this.$t('uncategorized'), icon: null, children: [], to: '', group: `${group}/category-0`,category_id: null}
    ] as any;

    // Cria um mapeamento para as categorias
    const mapCategories = {};

    // Preenche as categorias para o menu lateral
    this.formCategories.forEach((e: IFormCategory) => {
      const item = {title: e.name, icon: null, children: [], to: '', group: `${group}/category-${e.id}`, category_id: e.id}
      // Adiciona isso ao mapeamento para facilitar a localização desse elemento
      mapCategories[item.category_id] = item
      itens.push(item)
    })

    // Adiciona na lista de categorias
    this.menuForms.forEach((e) => {
      // mdi-file-plus-outline
      // Pula para o próximo item se não estiver habilitado
      if (!e.is_enabled) return;

      // Primeiro item do map é o para forms sem categorias
      let categoryMapItem = itens[0]

      if (e.form_category_id) {
        categoryMapItem = mapCategories[e.form_category_id]
      }

      const formItem = {title: e.title, icon: null, to: {name: route, params: {id: e.id}}, meta: metaValue}
      categoryMapItem.children.push(formItem);
    });

    // Para ordenar os itens internos por categoria.
    itens.forEach((item) => {
      item.children.sort((a, b) => a.title.localeCompare(b.title))
    })

    // itens = itens.filter(item => item.children.length > 0)
    return itens;
  }

  public get menuItemDefault() {
    return [
      {header: this.$t('form_batch')},

      {
        title: this.$t('form_batch'), icon: 'mdi-file-cabinet', to: '', group: 'main/form-batch',
        meta: {
          module: 'form_batch',
          method: 'show',
        },
        children: [

          {
            title: this.$t('crud.list-all'), icon: 'mdi-format-list-bulleted-square',
            to: {name: 'main-form-batch-list'}, meta: {module: 'form_batch', method: 'list'},
          },
          {
            title: this.$t('crud.register_new'), icon: 'mdi-plus-outline', to: {name: 'main-form-batch-create'},
            meta: {module: 'form_batch', method: 'create'},
          },
        ],
      },
      {header: this.$t('forms')},
      {
        title: this.$t('forms'), icon: 'mdi-text-box-multiple-outline', to: '', group: 'main/forms/create',
        meta: {module: 'form_values', method: 'show'},
        children: this.formItems('main-forms-create', {module: 'form_values', method: 'create'}, 'main/forms/create'),
      },
      {header: this.$t('registered-data')},
      {
        title: this.$t('registered-data'), icon: 'mdi-table-eye', to: '', group: 'main/forms/list',
        children: this.formItems('main-forms-list', {module: 'form_values', method: 'list'}, 'main/forms/list'),
      },
    ];
  }

  // TODO verificar uma forma de apresentar todos os campos sem precisar testar todas as vezes.
  public get menuItemAdmin() {
    return [
      {header: this.$t('admin')},
      {
        title: this.$t('users_menu'), icon: 'mdi-account-multiple', to: '', group: 'admin/users',
        meta: {module: 'users', method: 'show'},
        children: [
          {
            title: this.$t('crud.list-all'), icon: 'mdi-format-list-bulleted', to: {name: 'main-admin-users-list'},
            meta: {module: 'users', method: 'list'},
          },
          {
            title: this.$t('crud.register_new'), icon: 'mdi-account-plus', to: {name: 'main-admin-users-create'},
            meta: {module: 'users', method: 'create'},
          },
          // {title: 'Update', icon: 'mdi-update', to: 'main-admin-users-create'},
          {
            title: this.$t('external_users_menu'),
            icon: 'mdi-account-box-outline',
            to: '',
            group: 'admin/users/external-users',
            meta: {module: 'external_users', method: 'show'},
            children: [
              {
                title: this.$t('crud.list-all'),
                icon: 'mdi-format-list-bulleted',
                to: {name: 'main-admin-users-external-users-list'},
                meta: {module: 'external_users', method: 'list'},
              },
            ],
          },
        ],
      },
      {
        title: this.$t('roles'), icon: 'mdi-badge-account', to: '', group: 'admin/roles',
        meta: {module: 'roles', method: 'show'},
        children: [
          {
            title: this.$t('crud.list-all'),
            icon: 'mdi-format-list-bulleted',
            to: {name: 'main-admin-roles-list'},
            meta: {module: 'roles', method: 'list'},
          },
          {
            title: this.$t('crud.register_new'), icon: 'mdi-plus-outline', to: {name: 'main-admin-roles-create'},
            meta: {module: 'roles', method: 'create'},
          },
          // {title: 'Update', icon: 'mdi-update', to: 'main-admin-users-create'},
        ],
      },
      {
        title: this.$t('groups'), icon: 'mdi-account-group', to: '', group: 'admin/group',
        meta: {module: 'group', method: 'show'},
        children: [
          {
            title: this.$t('crud.list-all'),
            icon: 'mdi-format-list-bulleted',
            to: {name: 'main-admin-group-list'},
            meta: {module: 'group', method: 'list'},
          },
          {
            title: this.$t('crud.register_new'), icon: 'mdi-plus-outline', to: {name: 'main-admin-group-create'},
            meta: {module: 'group', method: 'create'},
          },
          // {title: 'Update', icon: 'mdi-update', to: 'main-admin-users-create'},
        ],
      },
      {
        title: this.$t('institutions'), icon: 'mdi-hospital-building', to: '', group: 'admin/institution',
        meta: {module: 'institution', method: 'show'},
        children: [
          {
            title: this.$t('crud.list-all'),
            icon: 'mdi-format-list-bulleted',
            to: {name: 'main-admin-institution-list'},
            meta: {module: 'institution', method: 'list'},
          },
          {
            title: this.$t('crud.register_new'), icon: 'mdi-plus-outline', to: {name: 'main-admin-institution-create'},
            meta: {module: 'institution', method: 'create'},
          },
        ],
      },
      {
        title: this.$t('forms'), icon: 'mdi-file-cog-outline', to: '', group: 'admin/forms',
        meta: {module: 'forms_admin', method: 'show'},
        children: [
          {
            title: this.$t('crud.list-all'),
            icon: 'mdi-format-list-bulleted',
            to: {name: 'main-admin-forms-list'},
            meta: {module: 'forms_admin', method: 'list'},
          },
          {
            title: this.$t('crud.register_new'), icon: 'mdi-plus-outline', to: {name: 'main-admin-forms-create'},
            meta: {module: 'forms_admin', method: 'create'},
          },
          {
            title: this.$t('forms_in_batch'),
            icon: 'mdi-file-upload-outline',
            to: {name: 'main-admin-forms-create-batch'},
            meta: {module: 'forms_values_admin', method: 'create'},
          },
          {
            title: this.$t('form_category'),
            icon: 'mdi-format-list-bulleted-type',
            to: '',
            group: 'admin/forms/form-category',
            meta: {module: 'form_category', method: 'show'},
            children: [
              {
                title: this.$t('crud.register_new'),
                icon: 'mdi-plus-outline',
                to: {name: 'main-admin-forms-form-category-create'},
                meta: {module: 'form_category', method: 'create'},
              },
              {
                title: this.$t('crud.list-all'),
                icon: 'mdi-format-list-bulleted',
                to: {name: 'main-admin-forms-form-category-list'},
                meta: {module: 'form_category', method: 'list'},
              },
            ],
          },
          // {
          //   title: this.$t('form_category'),
          //   icon: 'mdi-file-upload-outline',
          //   to: {name: 'main-admin-forms-category'},
          //   meta: {module: 'forms_category', method: 'create'},
          // },
          // {title: 'Update', icon: 'mdi-update', to: 'main-admin-forms-create'},
        ],
      },
      {
        title: this.$t('form_search_engine'), icon: 'mdi-database-search-outline', to: '', group: 'admin/search-engine',
        meta: {module: 'form_search_engine', method: 'show'},
        children: [
          {
            title: this.$t('crud.list-all'),
            icon: 'mdi-format-list-bulleted',
            to: {name: 'main-admin-search-engine-list'},
            meta: {module: 'form_search_engine', method: 'list'},
          },
          {
            title: this.$t('crud.register_new'),
            icon: 'mdi-plus-outline',
            to: {name: 'main-admin-search-engine-create'},
            meta: {module: 'form_search_engine', method: 'create'},
          },
        ],
      },
      {
        title: this.$t('form_batch'), icon: 'mdi-file-cabinet', to: '', group: 'admin/form-batch',
        meta: {module: 'form_batch_admin', method: 'show'},
        children: [
          {
            title: this.$t('crud.list-all'),
            icon: 'mdi-format-list-bulleted',
            to: {name: 'main-admin-form-batch-list'},
            meta: {module: 'form_batch_admin', method: 'list'},
          },
          // {
          //   title: this.$t('crud.create'),
          //   icon: 'mdi-view-grid-plus',
          //   to: {name: 'main-admin-form-batch-create'},
          //   meta: {module: 'form_batch_admin', method: 'create'},
          // },
        ],
      },
      {
        title: this.$t('external_data'), icon: 'mdi-table-arrow-up', to: '', group: 'admin/external-data',
        meta: {module: 'external_data_admin', method: 'show'},
        children: [
          {
            title: this.$t('crud.list-all'),
            icon: 'mdi-format-list-bulleted',
            to: {name: 'main-admin-external-data-list'},
            meta: {module: 'external_data_admin', method: 'list'},
          },
          {
            title: this.$t('crud.register_new'), icon: 'mdi-plus-outline',
            to: {name: 'main-admin-external-data-create'},
            meta: {module: 'external_data_admin', method: 'create'},
          },
          // {title: 'Update', icon: 'mdi-update', to: 'main-admin-forms-create'},
        ],
      },
      {
        title: this.$t('logs'), icon: 'mdi-buffer', to: '', group: 'admin/printer-logs',
        meta: {module: 'printer_logs_admin', method: 'show'},
        children: [
          {
            title: this.$t('printer_logs'),
            icon: 'mdi-printer-search',
            to: {name: 'main-admin-printer-logs-list'},
            meta: {module: 'printer_logs_admin', method: 'list'},
          },
          {
            title: this.$t('access_log'),
            icon: 'mdi-format-list-bulleted',
            to: {name: 'main-admin-access-log-list'},
            meta: {module: 'access_log', method: 'list'},
          },
        ],
      },
    ];
  }

  public get cruds() {
    return [
      {title: this.$t('crud.create'), icon: 'mdi-plus-outline', to: ''},
      {title: this.$t('crud.read'), icon: 'mdi-file-outline', to: ''},
      {title: this.$t('crud.update'), icon: 'mdi-update', to: ''},
      {title: this.$t('crud.delete'), icon: 'mdi-delete', to: ''},
    ];
  }
}
